import { Box, Button, useTheme } from '@mui/material';
import React from 'react';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { faTimes } from '@fortawesome/sharp-regular-svg-icons';

export type FlexyFilterCleanupProps = {
    onClick: () => void;
};

export const FlexyFilterCleanup: React.FunctionComponent<FlexyFilterCleanupProps> = function (
    props,
) {
    const { onClick } = props;
    const { palette } = useTheme();

    return (
        <Box
            onClick={onClick}
            className="flexy-filter"
            sx={{
                padding: '4px 8px 4px 8px',
                borderRadius: '12px',
                display: 'flex',
                gap: '0 4px',
                alignItems: 'center',
                flexWrap: 'nowrap',
            }}
        >
            <Button
                color="inherit"
                sx={{
                    display: 'flex',
                    gap: '0 4px',
                    alignItems: 'center',
                    justifyContent: 'start',
                    padding: '0',
                    minWidth: 'auto',
                    fontSize: '13px',
                    fontWeight: '500',
                    lineHeight: '20.8px',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '150px',
                }}
            >
                <FaOptionIcon
                    color={palette.primary.dark}
                    icon={faTimes}
                />
                Effacer les filtres
            </Button>
        </Box>
    );
};
